import { all, fork } from 'redux-saga/effects';

import watchCartFreightRequest from './cartFreightRequest';
import watchProductFreightRequest from './productFreightRequest';

function* freightsSagas() {
  yield all([fork(watchCartFreightRequest), fork(watchProductFreightRequest)]);
}

export default freightsSagas;
